import { Component, OnInit } from '@angular/core';
import { first } from "rxjs/operators";
import { LigneFinancement } from "src/app/parametrage/core/model/ligneFinancement/ligneFinancement";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementMarche } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementMarche';
import { LigneFinancementMarcheService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-marche.service';
import { LigneFinancementService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement.service';

@Component({
  selector: "app-add-ligne-financement-marche",
  templateUrl: "./add-ligne-financement-marche.component.html",
  styleUrls: ["./add-ligne-financement-marche.component.scss"]
})
export class AddLigneFinancementMarcheComponent implements OnInit {
  ligneFinancementMarche: LigneFinancementMarche = new LigneFinancementMarche();

  ligneFinancement: LigneFinancement [];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementMarcheService: LigneFinancementMarcheService,
    private _ligneFinancementService: LigneFinancementService,

    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      montant: [null, Validators.compose([Validators.nullValidator])],
      libelle: [null, Validators.compose([Validators.required])],
      ligneFinancementId: [null, Validators.compose([Validators.required])],
      typeMarche: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.getAll();
  }

  save(): void {
    this.pressButton = true;
    this.ligneFinancementMarche = this.form2.value;

    this._ligneFinancementMarcheService
      .add(this.ligneFinancementMarche)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  getAll() {
    this._ligneFinancementService.getAllLigneFinancement().subscribe(
      data => {
        this.ligneFinancement = data;
      },
      error => {
        console.log(error);
      }
    );
  }
}
